module.exports = __webpack_public_path__ + "img/quick-payment.b7beac86.svg";